import { ReactNode } from 'react';

export enum CarouselVariant {
	Background = 'background',
	Container = 'container',
	Inverse = 'inverse',
}

export interface CarouselProps {
	className?: string;
	children: ReactNode[];
	variant?: CarouselVariant;
	hasGutter?: boolean;
	onLargeGrid?: boolean;
	hasBackground?: boolean;
}
